import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const InsetComponent = React.lazy(() => import("../Components/RootComponents/InsetComponent"));
const InsetPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <InsetComponent />
      </Suspense>
    </Fragment>
  );
};

export default InsetPage;
